import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LeftSideNavaBarAdmin from './LeftSideNavaBarAdmin';
import { MdEdit } from "react-icons/md";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { FaHome } from "react-icons/fa";
import { SiNamecheap } from "react-icons/si";
import { FaCodeMerge } from "react-icons/fa6";
import { MdOutlinePendingActions } from "react-icons/md";
import AdminTopNavbar from './AdminTopNavbar';

const CategoryManager = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [editCategoryName, setEditCategoryName] = useState('');
  const [editCategoryCode, setEditCategoryCode] = useState('');
  const [products, setProducts] = useState([]);
  const [message, setMessage] = useState('');

  const fetchCategories = async () => {
    try {
      const response = await axios.get('/api/edit/categories');
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/category/${id}`);
      setMessage('Category deleted successfully!');
      alert('Category deleted successfully!')
      fetchCategories();
    } catch (error) {
      console.error('Error deleting category:', error);
    }
  };

  const handleEditSave = async () => {
    try {
      await axios.put(`/api/category/${selectedCategory._id}`, {
        categoryName: editCategoryName,
        categoryCode: editCategoryCode,
      });

      const newProducts = products.filter((product) => !product._id);
      for (const newProduct of newProducts) {
        await axios.post(
          `/api/category/${selectedCategory._id}/product`,
          {
            productName: newProduct.productName,
            productCode: newProduct.productCode,
          }
        );
      }

      const existingProducts = products.filter((product) => product._id);
      for (const existingProduct of existingProducts) {
        await axios.put(
          `/api/category/${selectedCategory._id}/product/${existingProduct._id}`,
          {
            productName: existingProduct.productName,
            productCode: existingProduct.productCode,
          }
        );
      }

      setMessage('Category and products updated successfully!');
      alert('Category and products updated successfully!')
      setSelectedCategory(null);
      fetchCategories();
    } catch (error) {
      console.error('Error updating category or products:', error);
    }
  };

  const handleRemoveProduct = async (index) => {
    const productToRemove = products[index];
    try {
      if (productToRemove._id) {
        await axios.delete(
          `/api/category/${selectedCategory._id}/product/${productToRemove._id}`
        );
        setMessage('Product removed successfully!');
        alert('Product removed successfully!')
      }
      const updatedProducts = products.filter((_, i) => i !== index);
      setProducts(updatedProducts);
    } catch (error) {
      console.error('Error removing product:', error);
      setMessage('Error removing product.');
    }
  };

  const handleProductChange = (index, key, value) => {
    const updatedProducts = [...products];
    updatedProducts[index][key] = value;
    setProducts(updatedProducts);
  };

  const handleAddProduct = () => {
    setProducts([...products, { productName: '', productCode: '' }]);
  };

  return (
    <div>
     
      <style>
        {`
          

          .breadcrumb-wrap {
            background-color: #f5f5f5;
            padding: 15px 20px;
            margin-bottom: 20px;
          }

          .breadcrumb-title h2 {
            margin: 0;
          }

          .breadcrumb-menu {
            padding: 0;
            list-style: none;
            margin: 5px 0 0;
          }

          .breadcrumb-menu li {
            display: inline;
            margin-right: 5px;
          }



          .category-table th,
          .category-table td {
            border: 1px solid #ddd;
            padding: 10px;
            text-align: left;
          }

          .category-table th {
            background-color: #f4f4f4;
          }

          .modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .modal-content {
            background: #fff;
            padding: 20px;
            border-radius: 5px;
            width: 80%;
            max-width: 500px;
          }

          .modal-actions {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
          }

          button {
            padding: 8px 12px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }

          .edit-btn {
            background-color:rgb(89, 165, 246);
            color: white;
          }

          .delete-btn {
            background-color: #dc3545;
            color: white;
          }

          .save-btn {
            background-color:rgb(30, 70, 101);
            color: white;
          }

          .cancel-btn {
            background-color: #6c757d;
            color: white;
          }

          .remove-btn {
            background-color: #ffc107;
            color: white;
          }

          .add-btn {
            background-color: #17a2b8;
            color: white;
          }

          .product-edit {
            margin-bottom: 10px;
          }

          .message {
            color: green;
            font-weight: bold;
          }
        `}
      </style>
       <AdminTopNavbar/>
            <div className='containerorder'  style={{ paddingTop: '250px' }}>
        <div className="row ">
          
          <div className='.col-xl-9.col-lg-12.order-xl-2.order-lg-1.order-md-1.order-1 {
  background-color: #ffffff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
  max-width: 100%;
  margin-bottom: 20px;
}'>
            <table className="category-table">

              <thead>
                <tr>
                  <th><FaHome /> Category ID</th>
                  <th><SiNamecheap /> Category Name</th>
                  <th><FaCodeMerge /> Category Code</th>
                  <th><MdOutlinePendingActions /> Actions</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((category) => (
                  <tr key={category._id}>
                    <td>{category.categoryId}</td>
                    <td>{category.categoryName}</td>
                    <td>{category.categoryCode}</td>
                    <td>
                      <button
                        className="edit-btn"
                        onClick={() => {
                          setSelectedCategory(category);
                          setEditCategoryName(category.categoryName);
                          setEditCategoryCode(category.categoryCode);
                          setProducts(category.Products || []);
                        }}
                      >
                        <MdEdit /> Edit
                      </button>
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(category._id)}
                      >
                        <RiDeleteBin6Fill /> Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {selectedCategory && (
              <div className="modal">
                <div className="modal-content">
                  <h3>Edit Category</h3>
                  <input
                    type="text"
                    value={editCategoryName}
                    onChange={(e) => setEditCategoryName(e.target.value)}
                    placeholder="Category Name"
                    style={{borderRadius:"3px",marginBottom:"7px",padding:"4px"}}
                  />
                  <input
                    type="text"
                    value={editCategoryCode}
                    onChange={(e) => setEditCategoryCode(e.target.value)}
                    placeholder="Category Code"
                    style={{borderRadius:"3px",marginBottom:"7px",padding:"4px"}}
                  />
                  <h4>Products</h4>
                  {products.map((product, index) => (
                    <div key={index} className="product-edit">
                      <input
                        type="text"
                        value={product.productName}
                        onChange={(e) =>
                          handleProductChange(index, 'productName', e.target.value)
                        }
                        placeholder="Product Name"
                        style={{borderRadius:"3px",marginBottom:"7px",padding:"4px"}}
                      />
                      <input
                        type="text"
                        value={product.productCode}
                        onChange={(e) =>
                          handleProductChange(index, 'productCode', e.target.value)
                        }
                        placeholder="Product Code"
                        style={{borderRadius:"3px",marginBottom:"7px",padding:"4px",margin:"2px"}}
                      />
                      <button
                        className="edit-btn"
                        onClick={() => handleRemoveProduct(index)}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  <button className="add-btn" onClick={handleAddProduct}>
                    Add Product
                  </button>
                  <div className="modal-actions">
                    <button className="save-btn" onClick={handleEditSave}>
                      Save
                    </button>
                    <button
                      className="cancel-btn"
                      onClick={() => setSelectedCategory(null)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryManager;
